import { Slider } from "../../components/slider.js";
import { BannersModel } from "./model.js";
import { BannerView } from "./view.js";

export class BannersController {
  static instance = null;

  constructor() {
    if (BannersController.instance) {
      throw new Error("Clase singleton, use getInstance()");
    }
    this.model = new BannersModel();
    this.view = new BannerView();
    window.addEventListener('resize', this.init.bind(this));
  }

  static getInstance() {
    if (!BannersController.instance) {
      BannersController.instance = new BannersController();
    }
    return BannersController.instance;
  }

  init() {
    this.model.getBanners()
      .then((_images) => {
        new Slider('banners', _images, false, true);
      })
      .catch(_error => {
        console.error('BannerController: ' + (_error || 'No se pueden cargar los banners.'))
      });
  }

  hide() {
    let dom = document.getElementById('banners');
    if (dom) {
      dom.setAttribute('style', 'display: none');
    }

  }


}


